/* ================================================================
   DROP DEAD — FAQ progressive enhancement
   - Smooth anchor scroll to a category group with header offset
   - Active-chip tracking via IntersectionObserver on category groups
   - Accordion works natively via <details>; JS is additive-only.
   ================================================================ */

(function () {
  'use strict';

  function headerOffset() {
    var val = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var px = parseInt(val, 10);
    if (isFinite(px) && px > 0) return px + 16;
    return 16;
  }

  function initFaq(root) {
    if (!root || root.dataset.ddFaqInit === '1') return;
    root.dataset.ddFaqInit = '1';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-dd-faq-chip]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-dd-faq-group]'));

    if (!chips.length || !groups.length) return;

    var chipByCat = {};
    chips.forEach(function (c) {
      chipByCat[c.getAttribute('data-dd-faq-chip')] = c;
    });

    function setActive(catId) {
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-dd-faq-chip') === catId);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        var href = chip.getAttribute('href') || '';
        var id = href.indexOf('#') === 0 ? href.slice(1) : '';
        var target = id ? document.getElementById(id) : null;
        if (!target) return;

        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
        setActive(chip.getAttribute('data-dd-faq-chip'));

        if (history && history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
      });
    });

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best) {
          var cat = best.target.getAttribute('data-dd-faq-group');
          if (cat) setActive(cat);
        }
      },
      {
        rootMargin: '-35% 0px -55% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    groups.forEach(function (g) {
      observer.observe(g);
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-dd-faq]');
    for (var i = 0; i < roots.length; i++) initFaq(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    var roots = e.target.querySelectorAll ? e.target.querySelectorAll('[data-dd-faq]') : [];
    for (var i = 0; i < roots.length; i++) initFaq(roots[i]);
    if (e.target.hasAttribute && e.target.hasAttribute('data-dd-faq')) initFaq(e.target);
  });
})();
